import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import './Tags.scss';

const Tags = props => {
  const { color, tags } = props;
  return (
    <div className="tags">
      {tags.map((tag, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Badge color={color} key={i}>
          {tag}
        </Badge>
      ))}
    </div>
  );
};

Tags.propTypes = {
  color: PropTypes.oneOf([
    'default',
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
    'light',
    'dark',
  ]),
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
};

Tags.defaultProps = {
  color: 'secondary',
};

export default Tags;
